import axios from '../../axios';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { TLessonProgressBase, TUpdateProgress, TError } from '@onesource/schemas';
import { getProgressQueryKey } from './get-progress';

/**
 * Hook to update user's progress on a lesson
 * Automatically invalidates progress query on success
 *
 * @param lessonId - Lesson ID (UUID)
 */
export const useUpdateProgress = (lessonId: string) => {
  const queryClient = useQueryClient();

  return useMutation<TLessonProgressBase, TError, TUpdateProgress>({
    mutationFn: async data => {
      const res = await axios.patch<TLessonProgressBase>(`/community-hub/lessons/${lessonId}/progress`, data);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getProgressQueryKey(lessonId) });
    },
  });
};
